import { api } from '../api';
import type {
  CreateStationPayload,
  ListStationsParams,
  Station,
  UpdateStationPayload,
} from '@/types/station';

function buildQs(params: Record<string, unknown>): string {
  const sp = new URLSearchParams();
  for (const [k, v] of Object.entries(params)) {
    if (v == null) continue;
    sp.set(k, String(v));
  }
  const qs = sp.toString();
  return qs ? `?${qs}` : '';
}

export const stationRequests = {
  list: (params?: ListStationsParams) => api.get<Station[]>(`/stations${buildQs({ ...params })}`),

  create: (data: CreateStationPayload) => api.post<Station>('/stations', data),

  update: (id: number, data: UpdateStationPayload) => api.patch<Station>(`/stations/${id}`, data),

  remove: (id: number) => api.delete<{ deleted: boolean }>(`/stations/${id}`),
};
